// Parse a Virtual question's saved patterns once, the way its editor rows do: each answer's pattern
// trimmed, its base with numbers allowed (an open-ended answer carries none), and the question-level
// pattern only when it is an expression. Both the dependency list and the codes in use are read off
// this one parse, so a folded editor costs a single pass over its patterns.
export const parseSavedPatterns = ({
  parser,
  id,
  variant,
  answerVariants = [],
  pattern = '',
  patternType,
  clusters = []
}) => {
  const parse = (text, extra = {}) => ({
    text,
    result: parser.analyzeString({ id, filter: text, clusters, saveTokens: true, ...extra })
  })

  return {
    answers: answerVariants.map(item => ({
      pattern: parse((item.pattern || '').trim()),
      base: 'oex' === variant ? null : parse(item.base || '', { numberAllowed: true })
    })),
    question: 'expression' === patternType ? parse((pattern || '').trim()) : null
  }
}
